import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export const Hero = () => {
  return <section className="pt-20 bg-gradient-to-b from-brand-bg to-white" data-id="element-93">
      {/* Banner Image at the top */}
      <div className="w-full relative" data-id="element-94">
        <img src="https://cdn.magicpatterns.com/uploads/6sAF4F1dcc6nVMbJcymvPj/Banner_original.png" alt="Beauty Lab Studio" className="w-full h-auto object-contain" data-id="element-95" />
      </div>

      {/* Text Content Below Banner */}
      <div className="max-w-4xl mx-auto px-6 w-full py-12 md:py-20 flex flex-col items-center text-center" data-id="element-96">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="flex flex-col items-center" data-id="element-97">
          <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm mb-8 border border-brand-pink/20" data-id="element-98">
            <div className="flex text-brand-gold" data-id="element-99">
              {[...Array(5)].map((_, i) => <Star key={i} size={14} fill="currentColor" data-id="element-100" />)}
            </div>
            <span className="text-xs font-medium text-brand-dark/80" data-id="element-101">
              +3800 seguidoras en Instagram
            </span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-heading font-bold leading-tight mb-4 text-brand-dark" data-id="element-102">
            Belleza que te <span className="text-gradient" data-id="element-103">define</span>
          </h1>

          <h2 className="text-xl md:text-2xl font-medium text-brand-magenta mb-6 tracking-wide" data-id="element-104">
            Uñas · Cejas · Pestañas
          </h2>

          <p className="text-lg text-brand-dark/80 mb-10 max-w-2xl leading-relaxed font-medium" data-id="element-105">
            Un espacio dedicado a realzar tu belleza natural con profesionalismo
            y amor por cada detalle.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto justify-center" data-id="element-106">
            <a href="#contacto" className="bg-gradient-brand text-white px-8 py-4 rounded-full text-center font-medium hover:scale-105 transition-transform shadow-lg shadow-brand-pink/30" data-id="element-107">
              Reservá tu turno
            </a>
            <a href="#servicios" className="px-8 py-4 rounded-full text-center font-medium border-2 border-brand-pink text-brand-magenta hover:bg-brand-pink/5 transition-colors bg-white" data-id="element-108">
              Ver servicios
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
};